module.exports = __webpack_public_path__ + "static/media/52_A.6ef42862.png";